<template>
  <div class="container py-5 mx-auto md-layout">
    <div class="mx-auto md-layout-item md-small-size-100 md-size-60">
      <div class="md-layout-item md-size-100">
        <h1>Privacy Portal</h1>
        <p>
          We take the data and privacy rights of our users seriously. We have
          compiled our policies and tools on this page to make it easier to
          understand how we use our users' data to provide a better experience.
        </p>
      </div>
      <div class="md-layout-item md-size-100">
        <h2>Privacy Policy</h2>
        <p>
          To learn more about the data that ArtistHub collects, and how we use
          this data to provide a better service to our users, read our
          <a href="/legal/privacy/privacy-policy">Privacy Policy</a>.
        </p>
      </div>
      <div class="md-layout-item md-size-100">
        <h2>Pixel partners</h2>
        <p>
          When you visit an ArtistHub website, ArtistHub may use third-party
          pixel partners that process data on behalf of ourselve and our users.
          You may see our list of
          <a href="/legal/privacy/pixel-partners">Pixel Partners</a>.
        </p>
      </div>
      <div class="md-layout-item md-size-100">
        <h2>End-user GDPR requests</h2>
        <p>
          ArtistHub is ready to help you fulfill end-user GDPR requests. Email
          us at privacy@artisthub.io to get started.
        </p>
      </div>
      <div class="md-layout-item md-size-100">
        <h2>Terms of Use</h2>
        <p>
          To learn about the agreement ArtistHub has with its users about our
          platform, read our <a href="/legal/terms-of-use">Terms of Use</a>.
        </p>
      </div>
      <div class="md-layout-item md-size-100">
        <h2>Cookie Policy</h2>
        <p>
          To learn about how we use cookies to provide a better experience for
          users across our sites, read our
          <a href="/legal/privacy/cookie-policy">Cookie Policy</a>.
        </p>
      </div>
      <div class="md-layout-item md-size-100">
        <h2>Single Click Opt-Out</h2>
        <p>
          If you prefer that we do not collect non-personally identifiable
          information about your visits for the purpose of delivering targeted
          advertising, you may opt out by clicking the OPT-OUT button.
        </p>
        <md-button class="md-danger">Opt-Out</md-button>
      </div>
      <div class="md-layout-item md-size-100">
        <h2>Contact Us</h2>
        <p>
          If you have any questions about our privacy policies, you may email us
          at privacy@artisthub.io.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
